import React, { Component } from 'react';
import { Button, Modal, Table } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';


class ConversionParams extends Component {
    state = {
        visible: false,
        data: [],
        invFactor: '',
    }

    show = () => {
        this.setState({
            visible: true,
        },() => {
            this.loadData();
        });
    }

    loadData = () => {
        const { invId } = sessionStorage;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.plan.queryConversionFactor,
            data: {
                investigationId: invId,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, invFactor } = res;
                this.setState({
                    loading: false,
                    data: datas,
                    invFactor,
                });
            }
        };
        $.sendRequest(options);
    };

    hide = () => {
        this.setState({
            visible: false,
            data: [],
            invFactor: '',
        });
    }

    getColumns = () => {
        const columns = [{
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            width: 60,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 60,
        }, {
            title: '合同计划单访视工时折算系数',
            dataIndex: 'visitHourConversionFactor',
            key: 'visitHourConversionFactor',
            width: 100,
        }];
        return columns
    }

    render() {
        const { visible, data, loading, invFactor } = this.state;
        return (
            <Modal
                title="合同计划单访视工时折算系数"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="600px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div style={{ padding: '30px 20px' }}>
                    <div style={{ marginBottom: 10 }}>合同计划单访视工时=合同计划单访视工时折算系数*单访视工时</div>
                    <div style={{ marginBottom: 10 }}>项目合同计划单访视工时折算系数：{invFactor}</div>
                    <div style={{ 
                        marginBottom: 30, 
                        whiteSpace: 'normal',
                        color: '#9999ff',
                    }}>
                        说明：合同计划单访视工时折算系数≥1，表示该项目访视计划工时≥访视完成工时；合同计划单访视工时折算系数＜1，表示该项目访视计划工时＜访视完成工时；项目合同计划单访视工时折算系数≤中心合同计划单访视工时折算系数，表示中心访视进度快于项目进度；项目合同计划单访视工时折算系数＞中心合同计划单访视工时折算系数，表示中心访视进度慢于项目进度
                    </div>
                    <div style={{ marginBottom: 10 }}>与项目合同计划单访视工时折算系数不同的中心情况：</div>
                    <Table
                        dataSource={data}
                        bordered
                        loading={loading}
                        columns={this.getColumns()}
                        pagination={false}
                    />
                </div>
            </Modal>
        )
    }
}

export default ConversionParams;


// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/ConversionParams.js